<template>
    <div class="printManagementDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="900px">
            <div class="dialogContent" v-loading="loading">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
                    <el-form-item label="产品标题" prop="name">
                        <el-input v-model="form.productName" placeholder="请输入服务名称"></el-input>
                    </el-form-item>
                    <el-form-item label="产品效果图" prop="urlList">
                        <div style="display: flex;flex-wrap: wrap;">
                            <div class="imgListClass"
                                 v-for="(item,index) in form.urlList" v-if="item">
                                <el-image
                                    :src="item.urlPath" :preview-src-list="previewList">
                                </el-image>
                                <div class="img-cover-wrap">
                                    <i @click.stop="del(index)" class="el-icon-error"></i>
                                </div>
                            </div>
                        </div>
                        <el-upload
                            action="/service-center/upload/file/single"
                            :headers="headers"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload" class="thumbnailClass">
                            <div class="avatar">
                                <el-button>点击上传</el-button>
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item prop="sort" label="排序">
                        <el-input-number v-model="form.sort" :min="1"></el-input-number>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {
        addPresentationList,
        getPresentationDetail,
        editPresentation
    } from "../../../utils/interface";
    export default {
        data() {
            return {
                id: '',
                dialogVisible: false,
                loading: false,
                title: '',
                headers: {
                    'Authorization': 'Bearer ' + $cookies.get("api_access_token")
                },
                form: {
                    productName: '',
                    urlList: [],
                    sort: '1'
                },
                rules: {
                    productName: [
                        {required: true, message: '请输入产品标题', trigger: 'blur'}
                    ],
                    urlList: [
                        {required: true, message: '请上传图片'}
                    ],
                    sort: [
                        {required: true, message: '请设置排序',trigger: 'change'}
                    ],
                },
                previewList: []
            }
        },
        components: {},
        methods: {
            init(type,id) {
                this.dialogVisible = true
                this.reset()
                if (type === 'add') {
                    this.title = '新增'
                    this.id = ''
                } else {
                    this.title = '编辑'
                    this.id = id
                    this.getDetail(id)
                }
            },
            // 效果图上传
            handleAvatarSuccess(res, file) {
                this.form.urlList.push({
                    urlName: res.name,
                    urlPath: res.url
                })
                this.previewList.push(res.url)
                this.$refs.ruleForm.validateField('urlList')
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type.indexOf('image') !== -1;
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.warning('上传图片只能是图片格式!');
                }
                if (!isLt2M) {
                    this.$message.warning('上传图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            reset(){
                this.previewList = []
                this.form.productName = ''
                this.form.urlList = []
                this.form.sort = '1'
                this.form.uuid = ''
            },
            // 图片删除
            del(index){
                this.form.urlList.splice(index,1)
                this.previewList.splice(index,1)
                this.$refs.ruleForm.validateField('urlList')
            },
            // 提交
            submit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        if(this.id){
                            let data = {
                                uuid: this.id,
                                ...this.form
                            }
                            editPresentation(data).then((res)=>{
                                this.$message.success('保存成功！')
                                this.loading = false
                                this.dialogVisible = false
                                this.$emit('submit')
                            })
                        } else {
                            addPresentationList(this.form).then((res)=>{
                                this.$message.success('保存成功！')
                                this.loading = false
                                this.dialogVisible = false
                                this.$emit('submit')
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            // 查询详情
            getDetail(id){
                getPresentationDetail({uuid:id}).then((res)=>{
                    if(res.success){
                        this.form = res.data
                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .dialogContent {
        padding: 0 5%;
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 80px;
            height: 80px;
        }
        /deep/.el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 80px;
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 80px;
            height: 80px;
        }
        /deep/.el-image__inner{
            width: 275px;
            height: 150px;
        }
        .thumbnailClass{
            button{
                width: 100px;
                background: #3d7fff;
                border: none;
                border-radius: 5px;
                font-size: 14px;
                color: #FFFFFF;
            }
        }
        .imgListClass{
            width: 275px;
            height: 150px;
            border: solid 1px #ececec;
            background-color: #f9f9f9;
            margin-right: 13px;
            margin-bottom: 13px;
            position: relative;
            &:hover{
                .img-cover-wrap{
                    display: block;
                }
            }
            /deep/.el-image__preview{
                width: 275px;
                height: 150px;
            }
            // 删除
            .img-cover-wrap {
                right: 5px;
                top: 5px;
                position: absolute;
                line-height: initial;
                display: none;
                i {
                    font-size: 22px;
                    color: #000;
                    display: inline;
                    cursor: pointer;
                }
            }
        }
        .endPeriodClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
        .submitButtonClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
        .detailsClass{
            /*/deep/.el-form-item__label{*/
            /*float: none;*/
            /*}*/
            /*/deep/.el-form-item__content{*/
            /*margin-left: 0 !important;*/
            /*}*/
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commodity/printManagement/productDisplayDialog.vue